<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId" :key="key" @input="closeInput")
      button.button.success(slot="trigger", v-if="item && !item.component") Edit
      a.fa-stack.fa-lg(slot="trigger", v-else)
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      .row
        .column
          //pre {{body}}
          label Token
          input(type="text", v-model="body.token")
          label Destination
          select(v-model="body.destination_type", @change="()=>body.destination_id = null")
            option(:value="null") Select an option
            option(v-for="(destination,key) in destinations" :value="key" ) {{destination}}

          selectize-plan(v-model="body.destination_id", :value-field="true", v-if="body.destination_type ==='App\\\\Models\\\\Plan'" )
          selectize-common-cost(v-model="body.destination_id", :value-field="true", v-if="body.destination_type ==='App\\\\Models\\\\CommonCost'")
          selectize-federation(v-model="body.destination_id", :value-field="true", v-if="body.destination_type ==='App\\\\Models\\\\Federation'")

        .column
          label Additional
            select(v-model="additional_type")
              option(:value="null") Select an option
              option(v-for="(destination,key) in destinations" :value="key" ) {{destination}}
          selectize-plan(v-model="additional_id", :value-field="true", v-if="additional_type ==='App\\\\Models\\\\Plan'" )
          selectize-common-cost(v-model="additional_id", :value-field="true", v-if="additional_type ==='App\\\\Models\\\\CommonCost'")
          selectize-federation(v-model="additional_id", :value-field="true", v-if="additional_type ==='App\\\\Models\\\\Federation'")
          button.small.button(@click="addAdditional", :disabled="additional_type === null || additional_id === null") Add
          .prop-item(v-for="(value, i) in body.additional")
            .input-group
              span.input-group-label {{value.class.split('\\')[value.class.split('\\').length -1]}}
              input.input-group-field(type="text" disabled, :value="value.id")
              .input-group-button
                button.button.warning.fa.fa-times(@click="()=>{body.additional.splice(i,1)}")
      ActionButton(slot="footer", :action="save") Save
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel


</template>

<script>
import DatePicker from '../../components/structure/DatePicker'
import StartEndTimePicker from './StartEndTimePicker'
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import MaggieHelper from '../../maggieHelper'
import ActionButton from '../../components/structure/ui/ActionButton'
import SelectizeCommonCost from '../../components/structure/ui/lists/selectize/SelectizeCommonCost'
import SelectizePlan from "../../components/structure/ui/lists/selectize/SelectizePlan";
import SelectizeFederation from "../../components/structure/ui/lists/selectize/SelectizeFederation";

export default {
  name: 'RegistrationTokenReveal',
  components: {
    SelectizeFederation,
    SelectizePlan, SelectizeCommonCost, ActionButton, ModalReveal, StartEndTimePicker, DatePicker
  },
  data() {
    return {
      destinations: {
        'App\\Models\\Plan': 'Plan',
        'App\\Models\\Federation': 'Federation',
        'App\\Models\\CommonCost': 'Common Cost',
      },
      body: {
        token: null,
        destination_type: null,
        destination_id: null,
        additional: [],
      },
      additional_type: null,
      additional_id: null,
      key:0
    }
  },
  created() {
    if (this.item !== null) {
      for (let key in this.item) {
        this.body[key] = this.item[key]
        if (key === 'additional' && this.item[key] === null || this.item[key] === "[]") {
          this.body[key] = []
        }
      }
    }
  },
  methods: {
    closeInput(event) {
      if(!event) {
        this.key++
      }
    },
    save() {
      if (this.type !== 'edit') {
        return KeplerBackofficeSdk.registrationTokens.make(this.body, () => {
          MaggieHelper.notification('', 'token created')
          this.body = {}
          this.$emit('itemUpdated')
          this.$refs[this.componentId].close()
          window.location.reload()
        })
      }

      return KeplerBackofficeSdk.registrationTokens.select(this.item.id).edit(this.body, (data) => {
        MaggieHelper.notification('', 'token updated')
        this.$emit('itemUpdated')
        this.$refs[this.componentId].close()
      })
    },
    addAdditional() {
      this.body.additional.push({class: this.additional_type, id: this.additional_id})
      this.additional_type = null

      this.additional_id = null
    }
  },
  computed: {
    componentId() {
      return this.item !== null ? `token-${this.item.id}` : `token-${this._uid}`
    },

  },
  props: {
    item: {
      type: Object,
      default: null
    },
    type: {
      default: null
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// RegistrationTokenReveal.vue?7df09d5e